import React from "react";
import NewIcon from "../../../../resources/themes/dashboard-v1/icons/new.svg";
import {Link} from "react-router-dom";

const AdoptionEntry = ({ entry }) => {
  const { id, pet_profile, pet_profile_id, created_at } = entry;
  const name = pet_profile?.name ?? "Unknown Pet";
  const image = pet_profile?.image ?? "";

  const createdAtFormatted = new Date(created_at).toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
  });

  return (
    <Link to={"/admin/adoptions/list/" + id}>
      <div className="col-12 d-flex align-items-center adoption-entry py-2">      
        <div className="col-3">
          <img src={image} alt="" className="pic" />
        </div>
        <div className="col-6">
          <div className="link">
            {name}
          </div>
          <p className="id">Pet ID: #{pet_profile_id}</p>
          <p className="date">{createdAtFormatted}</p>
        </div>
        <div className="col-3 d-flex align-items-center justify-content-center p-0">
          <img src={NewIcon} alt="" />
        </div>      
      </div>
    </Link>
  );
};

export default AdoptionEntry;
